<script lang="ts" context="module">
	import * as Sentry from "@sentry/sveltekit";
	import { page } from "$app/stores";
	import { getIsInsideConnect } from "$lib/components/currentUser";
	import VisitorToolbarLeftContent from "$lib/components/toolbar//VisitorToolbarLeftContent.svelte";
	import VisitorToolbarRightContent from "$lib/components/toolbar/VisitorToolbarRightContent.svelte";
	import Toolbar from "$lib/components/toolbar//Toolbar.svelte";
	import ToolbarLeftContent from "$lib/components/toolbar/ToolbarLeftContent.svelte";
	import ToolbarRightContent from "$lib/components/toolbar/ToolbarRightContent.svelte";
	import Trackers from "$lib/components/tracking/Trackers.svelte";
	import { csrfToken } from "$lib/stores/csrfTokenStore";
	import "../../app.min.css";
	import { env } from "$lib/env.client";
	import Toast from "$lib/components/toast/Toast.svelte";
	import { createToastStore } from "$lib/components/toast/toastStore";
	import CopyFromSmoreToast from "$lib/components/toast/CopyFromSmoreToast.svelte";
	import { createCopyFromSmoreStore } from "$lib/components/connect/copyFromSmoreStore";
	import { browser } from "$app/environment";

	const CONNECT_CSS_CLASS = "inside-connect";
</script>

<script lang="ts">
	const isLoggedIn = !!$page.data.loggedInUser;

	const isInsideConnect = getIsInsideConnect();

	csrfToken.set($page.data.csrf);

	if (isLoggedIn) {
		// Logged-in user
		if (env.logToSentry) {
			Sentry.setUser({
				id: $page.data.loggedInUser.id,
				email: $page.data.loggedInUser.email,
				username: $page.data.loggedInUser.name,
				ip_address: "{{auto}}"
			});
		}

		createToastStore();
		createCopyFromSmoreStore();

		const isInIframe = browser && window.location != window.parent.location; // This also works: window.self !== window.top

		if (isInsideConnect && browser) {
			if (isInIframe) {
				// The header `Content-Security-Policy` in "hooks.server.ts" should protect us here
			} else {
				// Running from a Connect-only subdomain, but not within an iframe
				// --> Redirect to Connect and pass the current URL.
				document.body.innerHTML = "";
				document.location.href = `https://${env.PUBLIC_CONNECT_PARENT_HOST}/announcements-smore/new?redirect=${encodeURIComponent(window.location.href)}`;
			}

			if (!document.body.classList.contains(CONNECT_CSS_CLASS)) {
				document.body.classList.add(CONNECT_CSS_CLASS);
			}
		}
	} else {
		// Visitor
	}
</script>

<svelte:head>
	{#if $page.data.noIndexing}
		<meta name="robots" content="noindex, nofollow, noimageindex" />
	{/if}

	{#if !$page.data.useCustomFavicon}
		<link rel="shortcut icon" type="image/x-icon" href="https://cdn.smore.com/favicon.ico" />
	{/if}
</svelte:head>

{#if browser}
	{#if isLoggedIn}
		{#if $page.url.pathname.startsWith("/admin")}
			<slot />
		{:else}
			{#if !isInsideConnect && !$page.data.hideToolbar}
				<Toolbar>
					<svelte:fragment slot="left-side">
						<ToolbarLeftContent />
					</svelte:fragment>
					<svelte:fragment slot="right-side">
						<ToolbarRightContent />
					</svelte:fragment>
				</Toolbar>
			{/if}

			<slot />

			<Toast />

			{#if isInsideConnect}
				<CopyFromSmoreToast />
			{/if}
		{/if}
	{:else}
		<!-- Visitor -->

		{#if !$page.data.hideToolbar}
			<Toolbar>
				<svelte:fragment slot="left-side">
					<VisitorToolbarLeftContent />
				</svelte:fragment>
				<svelte:fragment slot="right-side">
					<VisitorToolbarRightContent />
				</svelte:fragment>
			</Toolbar>
		{/if}

		<slot />
	{/if}

	<Trackers />
{/if}

<style>
	:global(body),
	:global(html) {
		scroll-behavior: smooth;
	}
</style>
